import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H4 from '@base/H4/H4';
import {
  getQuizDetails,
  getCurrentSessionUID,
  getCurrentQuizType
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { mediaQuery, Spacings } from '@styles/index';
import InfoCard from './InfoCard';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_14B};
  grid-column: span 24;
  display: flex;
  justify-content: space-between;

  ${mediaQuery.uptoTablet} {
    grid-column: auto;
    width: 100%;
    margin-top: ${Spacings.SPACING_4B};
    flex-flow: column;
  }
`;

const Heading = styled(H4)`
  padding-left: ${Spacings.SPACING_12B};

  ${mediaQuery.uptoTablet} {
    padding-left: ${Spacings.SPACING_4B};
  }
`;

const CardWrapper = styled.div`
  width: 65%;

  ${mediaQuery.uptoTablet} {
    width: 100%;
  }
`;

const Attachments = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const sessionUID = useSelectorWithShallowEqual(getCurrentSessionUID);
  const { isSubjective } = useSelectorWithShallowEqual(getCurrentQuizType);

  const getItems = () => {
    const items = [];

    const showQuestionPaper =
      isSubjective &&
      (sessionUID || quizDetails.previous_sessions?.length) &&
      quizDetails.question_paper;

    if (showQuestionPaper) {
      items.push({
        title: 'Download question paper',
        onClick: () => {
          window.open(quizDetails.question_paper, '_blank');
        }
      });
    }

    return items;
  };

  const attachmentsToRender = getItems();

  if (!attachmentsToRender.length) {
    return null;
  }

  return (
    <Wrapper>
      <Heading>Attachments</Heading>
      <CardWrapper>
        {attachmentsToRender.map((attachment, index) => (
          <InfoCard
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            title={attachment.title}
            subText={attachment.subText}
            onClick={attachment.onClick}
          />
        ))}
      </CardWrapper>
    </Wrapper>
  );
};

export default Attachments;
